import {Card} from "../../../../../components/card/card.jsx";
import AlarmsCard from "./alarms-card.jsx";
import TopNaturesCard from "./top-natures-card.jsx";
import AccompanimentCard from "./accompaniment-card.jsx";

export default function MonitoringCard({ monitoringData }) {
    return (
        <Card className="dash-main-card col-span-48 row-span-1 min-h-0 min-w-0">
            <Card.Header className="border-b-0! bg-transparent!">
                <Card.Title className="bg-transparent text-[#F4FFFF] text-center w-full text-(length:--font-lg)!">
                    Monitoramento
                </Card.Title>
            </Card.Header>
            <Card.Body className="flex-1 min-h-0 flex px-(--dash-pad-md)! pb-(--dash-pad-md)!">
                <section className="flex-1 min-h-0 min-w-0 grid grid-cols-48 gap-[20px]">
                    <AlarmsCard monitoring={monitoringData} />

                    <TopNaturesCard natures={monitoringData} />

                    <AccompanimentCard accompaniment={monitoringData} />
                </section>
            </Card.Body>
        </Card>
    )
}
